/** @prettier */

import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

//言語jsonファイルのimport
import translationEn from './english.json';
import translationDe from './german.json';
import translationNl from './dutch.json';
import translationIt from './italian.json';
import translationEs from './spanish.json';
import translationFr from './french.json';
import translationEl from './greek.json';
import translationPl from './polish.json';
import translationPt from './portuguese.json';
import translationTr from './turkish.json';

//読み込んだ言語ファイルを選択可能にする
const resources = {
  english: {
    translation: translationEn,
  },
  german: {
    translation: translationDe,
  },
  dutch: {
    translation: translationNl,
  },
  italian: {
    translation: translationIt,
  },
  spanish: {
    translation: translationEs,
  },
  french: {
    translation: translationFr,
  },
  greek: {
    translation: translationEl,
  },
  polish: {
    translation: translationPl,
  },
  portuguese: {
    translation: translationPt,
  },
  turkish: {
    translation: translationTr,
  },
};

//初期化処理
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'english',
    fallbackLng: 'english',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
export default i18n;
